export const getView = (input: Element | Document) =>
  ('body' in input ? input : input.ownerDocument).defaultView

export const getNodeChildren = (parent: HTMLElement) => {
  const view = getView(parent)
  return Array.from(parent.children).filter((node): node is HTMLElement =>
    view ? node instanceof view.HTMLElement : false,
  )
}
